<template>
  <v-container fluid class="background-img login-page-new d-flex justify-center align-center">
    <!-- <v-row justify="center" class="login-row login-card-row">
      <v-col cols="11" md="6" lg="6" align-self="center" class="pa-0">
        <div>
          <v-alert
            prominent
            type="error"
          >
            <v-row align="center" class="alert-header">
              <v-col class="grow">
                ประกาศการเปลี่ยนแปลง: ระบบได้ทำการย้ายไปยัง https://certificate.niems.go.th เพื่อยกระดับประสิทธิภาพการให้บริการที่ดียิ่งขึ้น กรุณาเข้าถึงระบบผ่านทางลิงก์ใหม่ 
              </v-col>
              <v-col class="shrink">
                <v-btn @click="goToPRD">ไปที่ลิงก์ใหม่</v-btn>
              </v-col>
            </v-row>
          </v-alert>
        </div>
        <v-card flat class="login-card">
          <v-card-title class="pl-0 pt-10 login-header-block">
            <div class="py-2 pl-2 pr-3 login-header">
              <v-avatar size="35" color="#FFF9C4">
                <v-img src="imageLogo.svg"></v-img>
						</v-avatar>
              ระบบลงทะเบียนผู้ผ่านการฝึกอบรม และเปลี่ยนผ่าน/เทียบเท่า
            </div>
          </v-card-title>
          <v-card-text class="pt-13 pb-10">
            <v-form ref="form" lazy-validation @submit.prevent="login">
              <v-row class="login-row">
                <v-col cols="5" md="3" lg="3" align-self="center" class="pl-0 login-title">
                  <b>Username :</b>
                </v-col>
                <v-col cols="7" md="8" lg="8" class="px-0">
                  <v-text-field dense outlined hide-details rounded background-color="white"
                    class="login-text" :rules="rules.required" v-model="username" :readonly="loading"></v-text-field>
                </v-col>
              </v-row>
              <v-row class="mt-0 login-row">
                <v-col cols="5" md="3" lg="3" align-self="center" class="pl-0 login-title">
                  <b>Password :</b>
                </v-col>
                <v-col cols="7" md="8" lg="8" class="px-0">
                  <v-text-field dense outlined hide-details rounded background-color="white"
                    :type="open_password ? 'text' : 'password'" :append-icon="open_password ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="open_password = !open_password" class="login-text" :rules="rules.required" v-model="password" :readonly="loading"></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="center" class="mt-11 login-row">
                <v-btn depressed large rounded color="#3495cf" :loading="loading" :disabled="loading" type="submit"
                  class="px-10 login-btn">
                  <b>Login</b>
                </v-btn>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>  
        <div class="pt-5" >
        <v-btn style="border-radius: 40px !important;" block depressed x-large dark color="rgb(94, 174, 235)" class="select-regis-test-btn" to="/search_certificated" >
				<v-icon color="#fff9c4" class="select-regis-test-icon">mdi mdi-text-box-search-outline</v-icon>
					<b class="ml-2">ค้นหาข้อมูลประกาศนียบัตรผู้ปฏิบัติการจากระบบลงทะเบียน</b>
				</v-btn>
      </div>
      </v-col>
    </v-row> -->
    <v-row justify="center" align="center" dense>
      <v-col cols="12" md="6" lg="5">
        <div class="d-flex justify-center align-center text-center">
          <v-card class="login-card-box px-6 py-13 px-sm-10" color="white" max-width="80%">
            <v-avatar size="100">
              <!-- <img src="../assets/imageLogo.svg" alt="logo"> -->
              <!-- <v-img src="../assets/new-logo.png"></v-img> -->
              <img src="/new-logo.png" alt="logo">
            </v-avatar>
            <v-card-title class="justify-center mb-3">
              <h3 class="login-header-text">ระบบลงทะเบียนผู้ผ่านการฝึกอบรม<span>และเปลี่ยนผ่าน/เทียบเท่า</span></h3>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-form ref="form" lazy-validation @submit.prevent="login">
                <v-row class="mb-0" justify="center" align="center" dense>
                  <v-col cols="12" sm="10">
                    <v-row justify="center" align="center" dense>
                      <v-col cols="12" class="pb-0">
                        <v-text-field class="login-text-field border-radius-custom" dense outlined
                          background-color="white" label="Username" height="45px" :rules="rules.requiredUsername"
                          v-model="username" :readonly="loading" prepend-inner-icon="mdi mdi-account">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-text-field class="login-text-field border-radius-custom" dense outlined
                          background-color="white" :type="open_password ? 'text' : 'password'"
                          :append-icon="open_password ? 'mdi-eye' : 'mdi-eye-off'"
                          @click:append="open_password = !open_password" label="Password" height="45px"
                          :rules="rules.requiredPassword" v-model="password" :readonly="loading"
                          prepend-inner-icon="mdi mdi-lock">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-btn class="login-btn-box white--text " color="#274C77" min-width="120px"
                  height="45px" :loading="loading" :disabled="loading" type="submit" depressed>
                  เข้าสู่ระบบ
                </v-btn>
              </v-form>
              <v-divider class="mt-5 mb-9" style="border-color: rgba(231, 236, 239, 1);"></v-divider>
              <v-row justify="center" align="center" dense>
                <v-col cols="12">
                  <v-btn class="login-search-upload white--text mb-2" width="100%" height="100%" min-height="45px"
                    color="#6096BA" @click="goToUpload('search_certificated')" depressed>
                    <v-icon class="mr-1" size="30">mdi mdi-text-box-search-outline</v-icon>
                    ค้นหาข้อมูลประกาศนียบัตรผู้ปฏิบัติการจากระบบลงทะเบียน
                  </v-btn>
                  <v-btn class="login-search-upload white--text mt-2" width="100%" height="100%" min-height="45px"
                    color="#6096BA" @click="goToUpload('upload_image')" depressed>
                    <v-icon class="mr-1" size="30">mdi mdi-cloud-upload-outline</v-icon>
                    ระบบฝากรูปภาพผู้ปฏิบัติการเพื่อขอรับประกาศนียบัตร
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <!-- <UatToPrdModal /> -->
  </v-container>
</template>

<script>
import { EventBus } from '../EventBus'
// import UatToPrdModal from '../components/UatToPrdModal.vue'
export default {
  components: {
    // UatToPrdModal
  },
  data: () => ({
    open_password: false,
    loading: false,
    rules: {
      requiredUsername: [v => !!v || 'กรุณากรอก Username'],
      requiredPassword: [v => !!v || 'กรุณากรอก Password'],
    },
    username: null,
    password: null
  }),
  mounted() {
    if (sessionStorage.sessionExpired == 'true') this.alertError('Session หมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง')
    this.$apiConfig.setToken(null)
    sessionStorage.clear()
    if (process.env.VUE_APP_CURRENT_SERVER == "UAT") {
      EventBus.$emit("open-dialog", "go to PRD")
    }
  },
  methods: {
    alertError(html = '', timer = 4000) {
      this.$swal({
        icon: 'error',
        showIcon: false,
        html: `
          <div class="custom-icon-wrapper">
              <svg class="custom-error-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 
                9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 
                0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"/></svg>
            <div class="custom-alert-text">
            ${html}
            </div>
          </div>
        `,
        showCloseButton: true,
        showConfirmButton: false,
        timer: timer,
        didOpen: () => {
          const closeBtn = document.querySelector('.swal2-close');
          if (closeBtn) {
            closeBtn.innerHTML = `
              <svg class="custom-close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" 
                  style="width: 20px; height: 20px; fill: red;">
                <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 
                210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 
                0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 
                45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 
                32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 
                342.6 150.6z"/>
              </svg>
            `;
          }
        },
        customClass: {
          popup: 'custom-alert-card',
          htmlContainer: 'custom-alert-text',
          icon: 'custom-alert-icon',
        }
      })
    },
    async login() {
      if (!this.$refs.form.validate()) {
        EventBus.$emit('alert-warning-login', 'กรุณากรอก Username และ Password ให้ครบถ้วน')
        return
      }
      try {
        this.loading = true
        const username = this.username, password = this.password;
        const { data } = await this.axios.post('/user/api/v1/login', { username, password });
        if (data.status) {
          let saveSession = {
            training_organization_name: data.data.training_organization_name,
            province: data.data.province,
            username: data.data.username,
          }
          if (data.data.is_admin) saveSession.is_admin = data.data.is_admin ?? false
          sessionStorage.userProfile = JSON.stringify(saveSession)
          this.$apiConfig.setToken(data.data.access_token)
          this.$router.replace({ name: 'select_regis' })
        }
      } catch (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          if (error.response.status == 401) {
            EventBus.$emit('alert-error-login', 'Username หรือ Password ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง')
          }
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          // console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loading = false
      }
    },
    goToUpload(type){
        this.$router.push({ path: '/Privacy_Policy', query: { type } })
    },
    goToPRD() {
      location.replace('https://certificate.niems.go.th')
    }
  },

}
</script>

<style>
/* .login-page {
  height: 100%;
} */

/* .login-row {
  width: 100%;
  margin: 0%;
}

.login-card-row {
  height: 100%;
}

.login-card {
  background-color: #c0e0f7 !important;
  border-radius: 10px 45px !important;
}

.login-header-block {
  padding-right: 2% !important;
}

.login-header {
  font-family: 'Noto Sans Thai', sans-serif;
  font-weight: 700;
  font-size: 20px;
  word-break: break-word;
  color: white;
  background-color: #3495cf;
  border-top-right-radius: 23px;
  border-bottom-right-radius: 23px;
}

.alert-header {
  font-family: 'Noto Sans Thai', sans-serif;
  font-weight: 500;
  font-size: 19px;
  word-break: break-word;
  border-top-right-radius: 23px;
  border-bottom-right-radius: 23px;
}

.login-title {
  font-family: 'Noto Sans Thai', sans-serif;
  font-size: 18px;
  color: black;
}

.login-text {
  font-family: 'Noto Sans Thai', sans-serif;
  font-size: 15px;
}

.login-btn {
  font-family: 'Noto Sans Thai', sans-serif;
  text-transform: capitalize;
  color: white !important;
  font-size: 18px !important;
}

.theme--light.login-btn.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: rgb(231 231 231) !important;
}


/*========================================*/

@media only screen and (max-width:600px) {

  /* css for mobile */
  /* .login-header-block {
    padding-right: 4% !important;
  }

  .login-header {
    font-size: 19px;
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
  }

  .login-text.v-text-field--rounded>.v-input__control>.v-input__slot {
    padding-left: 7% !important;
    padding-right: 7% !important;
  } */
}

.login-page-new {
  font-family: 'Noto Sans Thai', sans-serif;
  height: 100%;
  background-image: url('/new-bg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.login-card-box.v-card {
  border-radius: 28px;
  box-shadow: 0px 2.85px 10px 0px rgba(0, 0, 0, 0.2) !important;
}

.border-radius-custom {
  border-radius: 8px;
}

.login-header-text {
  font-weight: 700;
  font-size: 26px;
  line-height: 1.45;
  word-break: break-word;
  color: #274C77;
}

.login-header-text span {
  display: block;
}

.login-search-upload:not(.v-btn--round).v-size--default {
  font-weight: 600;
  font-size: 16px !important;
  border-radius: 12px;
}

.login-search-upload .v-btn__content {
  white-space: normal;
  text-align: center;
  display: block;
  width: 100%;
  height: 100%;
  line-height: 21px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.theme--light.login-text-field input {
  font-weight: 500;
  font-size: 16px;
  color: #224870;
}

.theme--light.login-text-field .v-label {
  font-weight: 500;
  font-size: 16px;
  top: 14px;
}

.v-text-field--outlined.v-input--dense .v-label--active {
  transform: translateY(-20px) scale(0.75);
}

.login-text-field .v-input__prepend-inner .v-icon {
  font-size: 26px;
  color: #224870;
}

.login-text-field .v-input__prepend-inner,
.login-text-field .v-input__append-inner {
  align-self: center;
  margin-top: 0 !important;
}

.login-btn-box {
  text-transform: none;
  font-weight: 700;
  font-size: 18px !important;
  border-radius: 10px;
}

@media only screen and (max-width: 600px) {
  .login-header-text span {
    display: inline;
  }
}
</style>